export default {
  devStoreConfig: false,
  api: {
    default: 'https://aqueous-escarpment-57094.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client10.js